import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./HeroSection.css";
import BannerSlider from "../Home/BannerSlider";

const POLL_MS = 30000;

function formatTime(d) {
  if (!d) return "";
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

function useIsMobile(maxWidth = 992) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= maxWidth);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= maxWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [maxWidth]);

  return isMobile;
}

const HeroSection = () => {


  return (
    <div className="container-fluid hero-container">
      {/* Banner */}
      <BannerSlider />
    </div>
  );
};

export default HeroSection;
